import type { SaleInvoice } from '@repo/pdf';

interface Store {
    store_name: string;
    store_address: string;
    store_phone_number: string;
    footer_thank_you_message?: string;
    footer_terms_and_conditions?: string;
    logo?: string;
    logo_type?: string;
}

export const mapPurchaseToInvoice = (order: any, store: Store): SaleInvoice => {
    //   const _totalQuantity = order.items.reduce(
    //     (sum, item) => sum + item.quantity,
    //     0,
    //   );
    const totalAmount = order.items.reduce(
        (sum: number, item: any) => sum + item.purchase_price * item.quantity,
        0,
    );

    return {
        customer: order.customer && {
            id: order.customer.serial_id
                ? formatCustomerId(order.customer.serial_id)
                : order.customer.id,
            email: order.customer.email,
            name: order.customer.name,
            phone: order.customer.phone_number,
        },
        date: new Date(order.created_at),
        discount: order.discount_value,
        discountType: order.discount_type,
        items: order.items.map((item: any) => ({
            productName: item.product.name,
            quantity: item.quantity,
            price: item.purchase_price,
            totalPrice: item.purchase_price * item.quantity,
        })),
        dueAmount:
            (order.payment?.total_price ?? 0) -
            (order.payment?.total_paid ?? 0),
        invoiceNumber: order.invoice_number,
        paidAmount: order.payment?.total_paid ?? 0,
        paymentMethod: order.payment?.payment_method ?? 'Cash',
        subTotalAmount: totalAmount,
        sellerName: order.user?.name || 'N/A',
        tax: order.tax ?? 0,
        totalAmount: order.payment?.total_price ?? 0,

        store: {
            name: store.store_name,
            address: store.store_address,
            phone: store.store_phone_number,
            thanksMessage: store.footer_thank_you_message,
            footerNotes: store.footer_terms_and_conditions,
        },
        logo: {
            image: store.logo || '',
            type: (store.logo_type || 'JPG') as any,
        },
    };
};

const formatCustomerId = (serialId: string) => {
    const prefix = '';
    const paddedId = serialId.toString().padStart(4, '0');
    return `${prefix}${paddedId}`;
};
